export type Volume = {
  number: string
  title: string
  subtitle: string
  body: string
  promise: string
  flag?: string
}

export const volumes: Volume[] = [
  {
    number: '01',
    title: 'Setup & Command Center',
    subtitle: 'From scattered to one page on the fridge.',
    body: 'Install the whole system in one honest afternoon. The Current-State Audit (what’s working, what’s drowning you, what you can stop doing today), the Minimum Viable Records worksheet, your Family Rhythm Map, the One-Page Command Center, and a guided three-hour Setup Day checklist.',
    promise:
      'By tonight, the whole homeschool fits on one page you can see from across the kitchen.',
  },
  {
    number: '02',
    title: 'The Year Plan',
    subtitle: 'A year in pencil. Margin on purpose.',
    body: 'Undated block planning instead of dates that break by February. The Block Planner, the Margin Week Planner, the Catch-Up Triage card, the Life-Event Re-Plan sheet for the year with a move, a baby, or a heavy season, and the thirty-minute Block Preview.',
    promise:
      'The year bends instead of breaking — and adjusting stops feeling like failing.',
  },
  {
    number: '03',
    title: 'The Weekly Engine',
    subtitle: 'Anchors, not hours.',
    body: 'The Weekly Reset Checklist, Daily Anchor cards, printable Kid Routine Cards in picture and text formats (tasks only — no ages, no levels, no labels printed anywhere), the Rotation Planner for running several kids at once, the Derailed-Day card, and the Reset Guard.',
    promise:
      'Twenty minutes on one afternoon: last week closed, this week set, coffee still warm.',
    flag: '★ The heart of the system',
  },
  {
    number: '04',
    title: 'The Minimal Logbook',
    subtitle: 'Five minutes a day. Boxes, retired.',
    body: 'A record system you’ll actually maintain. The Quick-Start Records Chooser, the five-minute daily log, generic optional modules (days, activities, books, work samples, photos), the monthly Keep-or-Toss checklist, and the Collection Binder map. Every field blank and configurable — you decide what goes in it, and you check your local requirements before you finalize it.',
    promise: 'You stop keeping everything, and you stop lying awake about it.',
  },
  {
    number: '05',
    title: 'The Home Systems',
    subtitle: 'Space, supplies, paper, and dinner — the layer everything stands on.',
    body: 'The Space Plan for any home from a dedicated room to a kitchen table, the Supply Inventory and Restock Runner, the Paper Flow Map that gives every sheet an address the moment it’s done, the Weekly Household Sync, the Purchase Research worksheet, and the Annual Budget tracker.',
    promise:
      'The house stops competing with the school day and starts running alongside it.',
  },
  {
    number: '06',
    title: 'Review & the Long Game',
    subtitle: 'Close clean. See far. Last.',
    body: 'Documentation-based progress views built from what you already logged, the thirty-minute Block Review, the Annual Review and Next-Year Handoff, the monthly Burnout Check-In, the Simplify Ladder for cutting load fast without abandoning the system, and year-in-review keepsake pages.',
    promise:
      'You can finally see how far you’ve come — and the person running all of it gets planned for too.',
  },
]

export const insideEveryVolume = [
  'Undated, so you can start on any week of any year',
  'Blank, configurable fields — nothing pre-filled, nothing assumed',
  'Reprintable masters marked ↻, printed as often as you need',
  'Letter and A4, built from the same source',
  'Ink-friendly by design: no heavy fills, no photos, no color required',
]
